import React from 'react';
import {Query, QueryResult} from 'react-apollo';
import {ErrorAlert} from '../ErrorAlert';

export interface QueryProviderProps {
  /** Query tag represented by gql-tag */
  query: any;
  /** Parameters for query request  */
  variables?: any;
  /** Pass fetched data to children component as callback */
  children: (data: any) => JSX.Element;
  /** Returns loader while fetching data */
  loader: JSX.Element;
}

const QueryProvider: React.FC<QueryProviderProps> = ({query, loader, children}) => {
  return (
    <Query query={query}>
      {({loading, error, data}: QueryResult) => {
        if (loading) {
          return loader;
        }

        if (error || !data) {
          return <ErrorAlert message={`Error! ${error.message}`} description="Try to refresh." />;
        }
        return children(data);
      }}
    </Query>
  );
};

export default QueryProvider;



// WEBPACK FOOTER //
// ./src/components/QueryProvider/QueryProvider.tsx